module.exports = __webpack_public_path__ + "fonts/UntitledSans-Medium.6cc0d14.woff";